import * as React from "react";
const SvgAirbyte = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 95.7 99",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#615EFF",
  fillRule: "evenodd",
  d: "M32.6 12C43.2.1 60.8-3.4 75.2 3.5c19.2 9.1 26.1 32.4 15.7 50.3L67.4 94.1c-1.3 2.3-3.5 3.9-6 4.6s-5.2.3-7.5-1l28.4-48.8c7.6-13 2.5-29.9-11.4-36.5-10.4-5-23.2-2.5-30.9 6.1-4.2 4.7-6.6 10.8-6.7 17.1s2.2 12.5 6.3 17.3q1.05 1.35 2.4 2.4L25.5 83.8c-.6 1.1-1.5 2.1-2.5 2.9s-2.2 1.4-3.5 1.7-2.6.4-3.8.3q-1.95-.3-3.6-1.2l18-31c-2.6-3.7-4.4-7.9-5.5-12.2l-11 19c-1.3 2.3-3.5 3.9-6 4.6S2.3 68 0 66.7l28.5-49.1c1.2-1.9 2.6-3.8 4.1-5.6m33 15.6c6.9 3.9 9.2 12.7 5.3 19.5l-27.4 47c-1.3 2.3-3.5 3.9-6 4.6s-5.2.3-7.5-1L55.4 54c-2-.4-4-1.3-5.6-2.5-1.7-1.2-3.1-2.8-4-4.6-1-1.8-1.6-3.8-1.7-5.9s.2-4.1.9-6.1c.7-1.9 1.9-3.7 3.4-5.1s3.3-2.5 5.2-3.2c2-.7 4.1-.9 6.1-.8 2.1.2 4.1.8 5.9 1.8m-10 8.9c-.5.4-.9.8-1.2 1.3-.4.8-.7 1.7-.6 2.5q.15 1.35.9 2.4c.5.7 1.3 1.2 2.1 1.5s1.8.3 2.6.1c.9-.2 1.6-.7 2.2-1.4s1-1.5 1.1-2.4 0-1.8-.4-2.6-1-1.5-1.8-1.9c-.5-.3-1.1-.5-1.7-.6s-1.2 0-1.8.1c-.4.3-.9.6-1.4 1",
  clipRule: "evenodd"
}));
export default SvgAirbyte;
//# sourceMappingURL=Airbyte.js.map